import React from 'react'
import { DeviceComponentProps } from '../types'
import EquipmentIPAddress from './components/EquipmentIPAddress'
import UIIPAddress from './components/UIIPAddress'

function DeviceIPAddress({ uiDevice, equipment }: DeviceComponentProps) {
  return (
    <React.Fragment>
      <EquipmentIPAddress equipment={equipment} />
      <UIIPAddress uiDevice={uiDevice} />
    </React.Fragment>
  )
}

export default DeviceIPAddress
